import {makeStyles} from '@material-ui/styles';

export const useStyles = makeStyles(theme => ({
    tabla: {
       borderCollapse: 'collapse',
       border: 'none',
       background: theme.palette.background.paper,
       color: theme.palette.text.primary,
       '& .MuiTableCell-root': {
          fontWeight: 'normal',
          height: '11px',
          fontSize: '14px',
          padding: '10px'
       },
       '& .MuiTableCell-head': {
          border: '1px 1px solid #8dcbff',
          borderRadius: '10px',
          borderTop: 'none',
          textAlign: 'center',
          borderLeft: 'none',
          borderRight: 'none',
          fontWeight: 'normal'
       },
       '& .MuiToolbar-regular': {
          fontSize: '14px',
          minHeight: '10px',
          marginTop: '1rem',
          marginBottom: '1rem',
          paddingLeft: '10px',
          paddingRight: '0px'
       },
       '& .MuiTypography-h6': {
          fontWeight: 'bold',
          fontSize: '10px',
          margin: '0px'
       },
       '& .firstMuiTable': {
          borderCollapse: 'separate',
          border: '1px solid lightgray',
          borderRadius: '10px'
       },
       '& .Mui-selected': {
          backgroundColor: '#DFF0FF'
       }
    }
 }));